// @flow
import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { QuestionFieldsets } from './SearchForm';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

const label = 'Native Questions';
const QuestionSearch = (props: *) => {
  const clientProps = useContext(ClientContext);

  if (clientProps && getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      /\/questions(?=\/|$)/,
      '/questions-search'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  return (
    <SearchView
      label={label}
      primaryFieldsets={QuestionFieldsets.primaryFieldsets}
      extraFieldsets={QuestionFieldsets.extraFieldsets}
      {...props}
    />
  );
};

QuestionSearch.label = label;

export default QuestionSearch;



// WEBPACK FOOTER //
// ./src/containers/search/Questions.js